var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.09 13.292q-1.839 0-1.84-2.112V2.826C.25 1.418.865.707 2.09.707h10.137c1.23 0 1.84.711 1.84 2.12v8.353c0 1.408-.61 2.112-1.84 2.112zm7.892-6.296 3.141 3.439V2.888c0-.711-.328-1.08-.908-1.08H2.102c-.586 0-.909.369-.909 1.08v7.547l1.746-1.84c.24-.26.493-.382.756-.382.276 0 .545.13.791.39L5.57 9.744 8.22 6.982c.27-.28.556-.41.879-.41.316 0 .627.144.884.424m-5.367.068c-.761 0-1.383-.724-1.383-1.613 0-.882.622-1.613 1.383-1.613.756 0 1.377.731 1.377 1.613 0 .889-.62 1.613-1.377 1.613"
  })));
};
export default SvgImage;